import React, { FC } from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import { MasterLayout } from '../layout/MasterLayout';
import { PrivateRoutes } from './PrivateRoutes';
import AuthLayout from '../layout/AuthLayout';
import { PublicRoutes } from './PublicRoutes';
import CompleteProfilePage from '../pages/CompleteProfile';
import { RootState } from '../states/reducers';
import { UserTypeId } from '../helpers/constants';
// import {MasterLayout} from '../../_metronic/layout/MasterLayout'
// import {PrivateRoutes} from './PrivateRoutes'
// import {Logout, AuthPage} from '../modules/auth'
// import {ErrorsPage} from '../modules/errors/ErrorsPage'
// import {RootState} from '../../setup'

const Routes: FC = () => {
  const { auth } = useSelector((state: RootState) => state);
  const isAuthenticated = auth.isAuthenticated;
  const profileCompleted = auth.authUser?.profileCompleted;

  return (
    <Switch>
      {!isAuthenticated ? (
        <>
          <AuthLayout>
            <PublicRoutes />
          </AuthLayout>
        </>
      ) : profileCompleted ? (
        <MasterLayout>
          <PrivateRoutes />
        </MasterLayout>
      ) : (
        <AuthLayout>
          <Route path='/complete-profile/' component={CompleteProfilePage} />
          <Redirect from='*' to='/complete-profile/' />
        </AuthLayout>
      )}
    </Switch>
  );
};

export { Routes };
